import { makeEroadStyles } from "../../../styles";

const useStyles = makeEroadStyles(
  (theme) => ({
    root: {
      margin: `${theme.spacing(2)}px 0 0 0`,
    },
  }),
  { name: "PageDescription" }
);

export { useStyles };
